import { colors, HexToRgba } from 'utils/colors'

const lightBlue = HexToRgba(colors.blue8, 0.5)
const lightGray4 = HexToRgba('#C5CEE0', 0.4)
const lightGray5 = HexToRgba('#8F9BB3', 0.4)
const lightGreen = HexToRgba('#36BB85', 0.4)
const lightOrange = HexToRgba('#F47735', 0.4)
const lightRed = HexToRgba('#E24C4C', 0.4)
const lighterRed = HexToRgba('#E24C4C', 0.1)
const lightYellow = HexToRgba('#F1A153', 0.4)
const lightPurple = HexToRgba('#9381FF', 0.4)

type VariantType = {
  bg?: string
  outline?: string
  outlineColor?: string
  color?: string
  ':hover': {
    outlineColor?: string
  }
  '& > svg': {
    color: string
  }
}

/**
 * Disabled badge style
 */
export const disabled: VariantType = {
  bg: lightGray4,
  color: 'gray5',
  ':hover': {
    outlineColor: 'gray5',
  },

  '& > svg': {
    color: 'gray5',
  },
}

/**
 * Gray badge style
 */
export const gray: VariantType = {
  bg: lightGray5,
  ':hover': {
    outlineColor: 'gray5',
  },

  '& > svg': {
    color: 'gray5',
  },
}

/**
 * Light gray badge style
 */
export const lightGray: VariantType = {
  bg: 'gray3',
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'gray5',
  },

  '& > svg': {
    color: 'gray5',
  },
}

/**
 * Green badge style
 */
export const green: VariantType = {
  bg: lightGreen,
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'green2',
  },

  '& > svg': {
    color: 'green2',
  },
}

/**
 * Orange badge style
 */
export const orange: VariantType = {
  bg: lightOrange,
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'orange',
  },

  '& > svg': {
    color: 'orange',
  },
}

/**
 * Red badge style
 */
export const red: VariantType = {
  bg: lightRed,
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'red',
  },

  '& > svg': {
    color: 'red',
  },
}

/**
 * Pale red badge style
 */
export const paleRed: VariantType = {
  bg: lighterRed,
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'red',
  },

  '& > svg': {
    color: 'red',
  },
}

/**
 * Yellow badge style
 */
export const yellow: VariantType = {
  bg: lightYellow,
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'yellow',
  },

  '& > svg': {
    color: 'yellow',
  },
}

/**
 * Invalid lead badge style
 */
export const yellowAlt: VariantType = {
  bg: 'yellow1',
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'yellow1',
  },

  '& > svg': {
    color: 'white',
  },
}

/**
 * Purple badge style
 */
export const purple: VariantType = {
  bg: lightPurple,
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'purple1',
  },

  '& > svg': {
    color: 'purple1',
  },
}

/**
 * Customer badge style
 */
export const greenAlt: VariantType = {
  bg: 'green',
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'green',
  },

  '& > svg': {
    color: 'white',
  },
}

/**
 * Invalid / lost lead contact type badge style
 */
export const disabledAlt: VariantType = {
  bg: 'gray3',
  color: colors.defaultText,
  ':hover': {
    outlineColor: 'gray3',
  },

  '& > svg': {
    color: 'white',
  },
}

/**
 * Blue badge - Callback task
 */
export const blue: VariantType = {
  bg: lightBlue,
  color: colors.defaultText,
  ':hover': {
    outlineColor: lightBlue,
  },

  '& > svg': {
    color: 'gray7',
  },
}

export const success: VariantType = {
  bg: HexToRgba(colors.green, 0.4),
  outline: `1px solid ${colors.green}`,
  color: colors.green2,
  ':hover': {
    outlineColor: HexToRgba(colors.green2, 0.6),
  },

  '& > svg': {
    color: colors.green2,
  },
}

export const danger: VariantType = {
  bg: HexToRgba(colors.red, 0.4),
  outline: `1px solid ${colors.red}`,
  color: colors.red,
  ':hover': {
    outlineColor: HexToRgba(colors.red, 0.6),
  },

  '& > svg': {
    color: colors.red,
  },
}
